import { render, staticRenderFns } from "./lamsAuthRegRecord.vue?vue&type=template&id=19d5a124&scoped=true&"
import script from "./lamsAuthRegRecord.vue?vue&type=script&lang=js&"
export * from "./lamsAuthRegRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d5a124",
  null
  
)

export default component.exports